export default "__VITE_ASSET__DaXpu3tc__"